module.exports = __webpack_public_path__ + "static/media/bike-to-bike.527b33a3.jpg";